import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorTitleCmdbAssets: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorTitleCmdbFieldSearch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorMessageCmdbFieldSearch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	infoSingleObjectMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningMultipleObjectsMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	infoObjectLimitReached: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningObjectLimitExceeded: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dropdownNumberOfSearchResultsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchPlaceholder: {
		id: 'servicedesk-cmdb-field-object-picker.search-placeholder',
		defaultMessage: 'Select or search for objects',
		description: 'Placeholder text shown in a search box for looking up CMDB Objects',
	},
	errorTitleCmdbAssets: {
		id: 'servicedesk-cmdb-field-object-picker.error-title-cmdb-assets',
		defaultMessage: 'Could not fetch Assets objects',
		description:
			'Error title informing the user that there was an error while fetching CMDB objects',
	},
	errorMessage: {
		id: 'servicedesk-cmdb-field-object-picker.error-message',
		defaultMessage: 'Please refresh the page and try again',
		description: 'Error message instructing the user to refresh the page and try again',
	},
	errorTitleCmdbFieldSearch: {
		id: 'servicedesk-cmdb-field-object-picker.error-title-cmdb-field-search',
		defaultMessage: "We couldn't fetch any objects for this field",
		description:
			'Error title informing the user that there was an error while searching for CMDB objects',
	},
	errorMessageCmdbFieldSearch: {
		id: 'servicedesk-cmdb-field-object-picker.error-message-cmdb-field-search',
		defaultMessage:
			'Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid.',
		description: 'Error message informing user the potential issues of failing CMDB object search',
	},
	infoSingleObjectMessage: {
		id: 'servicedesk-cmdb-field-object-picker.info-single-object-message',
		defaultMessage: 'This field can only store a single object',
		description: 'Info message informing user that the CMDB field can only have 1 CMDB object',
	},
	warningMultipleObjectsMessage: {
		id: 'servicedesk-cmdb-field-object-picker.warning-multiple-objects-message',
		defaultMessage:
			'This field is configured to store a single object. Remove some objects to save changes.',
		description:
			'Warning message that alert user of having multiple objects in a single-object CMDB field',
	},
	infoObjectLimitReached: {
		id: 'servicedesk-cmdb-field-object-picker.info-object-limit-reached',
		defaultMessage:
			'This field can only store {objectLimit, plural, one {# object} other {# objects}}.',
		description:
			'Info message informing user that the CMDB field can only store a certain number of objects when they have reached the limit',
	},
	warningObjectLimitExceeded: {
		id: 'servicedesk-cmdb-field-object-picker.warning-object-limit-exceeded',
		defaultMessage:
			'This field is configured to store {objectLimit, plural, one {# object} other {# objects}}. Remove some objects to save changes.',
		description:
			'Warning message informing user that the CMDB field can only store a certain number of objects when they have exceeded the limit',
	},
	dropdownNumberOfSearchResultsLabel: {
		id: 'servicedesk-cmdb-field-object-picker.dropdown-number-of-search-results-label',
		defaultMessage:
			'{numberOfSearchResults} search {numberOfSearchResults, plural, one {result} other {results}} {isLoading, select, true {(refreshing)} other {}}',
		description:
			'Warning message informing user that the CMDB field can only store a certain number of objects when they have exceeded the limit',
	},
});
export default messages;
